var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service_btn"},[_vm._t("default",function(){return [_c('i',{staticClass:"iconfont icon-wodekefu btn_server_icon",on:{"click":_vm.toService}})]}),(_vm.textShow)?_c('div',{staticClass:"service_text"},[_vm._v(_vm._s(_vm.$t('service_text')))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }